import AssetMetaDataContainer from 'componentsV2/AssestUpload/SingleUpload/AssetMetaDataContainer';
import ProductValidation from 'componentsV2/AssestUpload/SingleUpload/ProductValidation';
import { MetadataElement, MetadataElementList, TableData } from 'componentsV2/AssestUpload/SingleUpload/SingleUploadModel';
import { useEffect, useState } from 'react';

interface MetadataEditProps {
  assetDetail: any; // Replace 'any' with the actual type if available
  tableData: TableData[];
  shouldShowElement: (element: MetadataElement) => boolean;
  assetId?: string; // Optional prop for assetId
}

const MetadataEdit = ({ assetDetail,tableData,shouldShowElement,assetId }: MetadataEditProps) => {
  console.log('MetadataEdit',tableData);

  return (
    <div className="single-upload-content-wrapper">
      {assetDetail?.metadata_collection?.metadata_element_list?.map(
        (assetMetadata: any) =>
          assetMetadata.metadata_element_list.some((element: any) =>
            shouldShowElement(element)
          ) && (
            <AssetMetaDataContainer
              shouldShowElement={shouldShowElement}
              key={assetMetadata.id}
              assetMetadata={assetMetadata}
              tableData={tableData}
              assetId={assetId} // Pass assetId if needed
            />
          )
      )}
    </div>
  );
};

export default MetadataEdit;
